import React from 'react'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <footer className="footer-root">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-column footer-brand-col">
              <div className="footer-logo-wrapper">
                <div className="footer-logo-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M6 12h6M9 6v12m-3 0h6a6 6 0 1 0 0-12H6"></path>
                  </svg>
                </div>
                <span className="footer-brand-name">Dogeet</span>
              </div>
              <p className="footer-description section-content">
                {' '}
                The Dogecoin-first community bazaar. Much commerce, very local.
                Khajiit has wares if you have DOGE.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="footer-doge-ticker">
                <div className="footer-ticker-dot"></div>
                <span className="footer-ticker-label">DOGE/USD:</span>
                <span id="doge-price" className="footer-ticker-value">
                  Loading...
                </span>
              </div>
              <div className="footer-social-links">
                <a href="#">
                  <div aria-label="Twitter" className="footer-social-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M18 6L6 18M6 6l12 12"></path>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="Discord" className="footer-social-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <circle cx="12" cy="12" r="1"></circle>
                      </g>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-column">
              <h3 className="footer-col-title section-subtitle">Marketplace</h3>
              <ul className="footer-nav-list">
                <li className="footer-nav-item">
                  <a href="/map-of-local-listings">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"></path>
                      </svg>
                      <span>Explore Map</span>
                    </div>
                  </a>
                </li>
                <li className="footer-nav-item">
                  <a href="/browse-by-category">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        >
                          <path d="M16 10a4 4 0 0 1-8 0M3.103 6.034h17.794"></path>
                          <path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"></path>
                        </g>
                      </svg>
                      <span>Categories</span>
                    </div>
                  </a>
                </li>
                <li className="footer-nav-item">
                  <a href="/post-a-listing">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <path d="M8 12h8m-4-4v8"></path>
                        </g>
                      </svg>
                      <span>Post Listing</span>
                    </div>
                  </a>
                </li>
                <li className="footer-nav-item">
                  <a href="#">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <circle cx="12" cy="12" r="1"></circle>
                        </g>
                      </svg>
                      <span>Featured Ads</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-col-title section-subtitle">Community</h3>
              <ul className="footer-nav-list">
                <li className="footer-nav-item">
                  <a href="/community-rules-safety">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        >
                          <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                          <path d="m9 12l2 2l4-4"></path>
                        </g>
                      </svg>
                      <span>Safety Rules</span>
                    </div>
                  </a>
                </li>
                <li className="footer-nav-item">
                  <a href="/">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        >
                          <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0-18 0m9-3h.01"></path>
                          <path d="M11 12h1v4h1"></path>
                        </g>
                      </svg>
                      <span>About Us</span>
                    </div>
                  </a>
                </li>
                <li className="footer-nav-item">
                  <a href="#">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M14.5 7l-5 5M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20M9.5 7l5 5"></path>
                      </svg>
                      <span>Whitepaper</span>
                    </div>
                  </a>
                </li>
                <li className="footer-nav-item">
                  <a href="#">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <path d="m15 9l-6 6m0-6l6 6"></path>
                        </g>
                      </svg>
                      <span>Report Abuse</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-col-title section-subtitle">Stay Wow</h3>
              <p className="footer-newsletter-text section-content">
                {' '}
                Get weekly local deals and meme updates. No spam, only such wow.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <form
                action="/subscribe"
                method="POST"
                data-form-id="d6c17055-0c38-4575-b946-77d8b52b099a"
                className="footer-newsletter-form"
              >
                <div className="footer-input-group">
                  <input
                    type="email"
                    placeholder="shibe@moon.com"
                    required="true"
                    aria-label="Email Address"
                    id="thq_textinput_viIG"
                    name="textinput"
                    data-form-field-id="thq_textinput_viIG"
                    className="footer-input"
                  />
                  <button
                    type="submit"
                    id="thq_button_kg_g"
                    name="button"
                    data-form-field-id="thq_button_kg_g"
                    className="footer-submit-btn btn btn-primary btn-sm"
                  >
                    {' '}
                    Subscribe
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-legal">
              <span className="footer-copyright">
                &amp;copy; 2026 Dogeet Community Bazaar.
              </span>
              <div className="footer-legal-links">
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Privacy Policy</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Terms of Service</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Cookie Preferences</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-badge">
              <span className="footer-badge-text">
                Built for Shibe by Shibe
              </span>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<style>
        @keyframes pulse-green {0% {box-shadow: 0 0 0 0 rgba(46, 204, 113, 0.4);}
70% {box-shadow: 0 0 0 6px rgba(46, 204, 113, 0);}
100% {box-shadow: 0 0 0 0 rgba(46, 204, 113, 0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="footer-container4">
        <div className="footer-container5">
          <Script
            html={`<script defer data-name="footer-logic">
(function(){
  const dogePriceElement = document.getElementById('doge-price');

  async function fetchDogePrice() {
    try {
      const response = await fetch('https://api.coingecko.com/api/v3/simple/price?ids=dogecoin&vs_currencies=usd');
      const data = await response.json();
      const price = data.dogecoin.usd;
      
      if (dogePriceElement) {
        dogePriceElement.textContent = \`\$\${price.toFixed(4)}\`;
        dogePriceElement.style.animation = 'none';
        void dogePriceElement.offsetWidth;
        dogePriceElement.style.animation = 'pulse-text 0.5s ease-out';
      }
    } catch (error) {
      if (dogePriceElement) {
        dogePriceElement.textContent = 'Moon Bound';
      }
    }
  }

  fetchDogePrice();
  setInterval(fetchDogePrice, 60000);

  const style = document.createElement('style');
  style.textContent = \`
    @keyframes pulse-text {
      0% { transform: scale(1); color: var(--color-secondary); }
      50% { transform: scale(1.1); }
      100% { transform: scale(1); color: var(--color-primary); }
    }
  \`;
  document.head.appendChild(style);
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
